import NumberProperty from "./NumberProperty";
export default NumberProperty;
